import { BaseDrawArgs, getMiddleCenterBias, measureTextCached, roundedRect } from '@glideapps/glide-data-grid'

const itemMargin = 4

export function drawBubbles(args: BaseDrawArgs, data: readonly string[]) {
  const { rect, theme, ctx, highlighted } = args
  const { x, y, width: w, height: h } = rect
  const bubbleHeight = 20
  const bubblePad = 8
  const bubbleMargin = itemMargin
  let renderX = x + theme.cellHorizontalPadding

  const renderBoxes: { x: number; width: number }[] = []
  for (const s of data) {
    if (renderX > x + w) break
    const textWidth = measureTextCached(s, ctx, theme.baseFontFull).width
    renderBoxes.push({
      x: renderX,
      width: textWidth,
    })

    renderX += textWidth + bubblePad * 2 + bubbleMargin
  }

  ctx.beginPath()
  for (const rectInfo of renderBoxes) {
    roundedRect(
      ctx,
      rectInfo.x,
      y + (h - bubbleHeight) / 2,
      rectInfo.width + bubblePad * 2,
      bubbleHeight,
      theme.roundingRadius ?? bubbleHeight / 2
    )
  }
  ctx.fillStyle = highlighted ? theme.bgBubbleSelected : theme.bgBubble
  ctx.fill()

  for (const [i, rectInfo] of renderBoxes.entries()) {
    ctx.beginPath()
    ctx.fillStyle = theme.textBubble
    ctx.fillText(data[i], rectInfo.x + bubblePad, y + h / 2 + getMiddleCenterBias(ctx, theme))
  }
}
